import './App.css';
import './index.css'; 
import {Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import WelcomeComponent from './components/home/welcome.component';
import LoginFormComponent from './components/home/login.form.component';
import ForgotPasswordComponent from './components/home/forgot.password.component';
import ContactFormComponent from './components/home/contact.form.component';
import SmartDashboardComponent from './components/dashboard/smart.dashboard.component';
import ChangePasswordComponent from './components/dashboard/change.password.component';
import AboutComponent from './components/home/about.form.component';
import MembershipFormComponent from './components/membership/membership.form.component';
import { useEffect } from 'react';
import ExecutiveCouncilComponent from './components/home/executiveCouncil';
import CommitteeComponent from './components/home/committees';
import ActiveMemberComponent from './components/home/activeMember';
import RegisterComponent from './components/home/register.component';
import SponsorshipCards from './components/sponsorship/sponsorship.component';
import SmartVenue from './components/sponsorship/smartvenue.component';
import GalleryMainView from './components/gallery/galleryMainView.component';
import SponsorshipTable from './components/sponsorship/sponsorshipTable.component';



const ProtectedRoute = ({ children }) => {
  
  const navigate = useNavigate();
  let user = null;

  try {
    user = JSON.parse(localStorage.getItem("user")); // Safely parse user data
  } catch (error) {
    console.error("Error parsing user data:", error);
  }

  useEffect(() => {
    if (!user) {
      navigate("/", { replace: true }); // Redirect to home if not authenticated
    }
  }, [user, navigate]);

  return user ? children : null; // Only render children if user is authenticated
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]); // Runs every time the route changes

  return null;
};

function App() {
  
  return (
    <div className="App">
         <ScrollToTop />
        <Routes>
        <Route path="/" element={<WelcomeComponent />} />
        <Route path="/aboutus" element={<AboutComponent />} />
        <Route path="/executive-council" element={<ExecutiveCouncilComponent />} />
        <Route path="/committee-member" element={<CommitteeComponent />} />
        <Route path="/active-members" element={<ActiveMemberComponent />} />

        <Route path="/register" element={<RegisterComponent />} />
        <Route path="/login" element={<LoginFormComponent />} />
        <Route path="/forgot-password" element={<ForgotPasswordComponent />} />
        <Route path="/reset-password" element={<ChangePasswordComponent />} />
        <Route path="/contact" element={<ContactFormComponent />} />
        <Route path="/sponsorship" element={<SponsorshipCards />} />
        <Route path="/sponsor" element={<SponsorshipTable />} />
        <Route path="/smart-venue" element={<SmartVenue />} />
        <Route path="/gallery" element={<GalleryMainView />} />

        <Route path="/membership" element={ <ProtectedRoute><MembershipFormComponent /></ProtectedRoute>} />
        <Route path="/change-password" element={ <ProtectedRoute><ChangePasswordComponent /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><SmartDashboardComponent /></ProtectedRoute>}></Route>
       
        </Routes>
    </div>
  );
}

export default App;
